/**
 * Maps to the backend AppBundle\Enum\CashLocationDeviceType (int).
 * Values are stable — BANK=4 was appended without renumbering 0..3.
 */
export enum CashLocationDeviceType {
  POS = 0,
  SAFE = 1,
  KIOSK = 2,
  OTHER = 3,
  BANK = 4,
}
